export function AuthVerifyCtrl (
  $scope,
  $stateParams,
  $translate,
  jsonApi,
  loginApi,
  messages,
  workshopAPI
) {
  $scope.init = function () {
    const queryParameters = jsonApi.getQueryParameters();

    $scope.customer_id     = queryParameters.customer_id;
    $scope.subscription_id = queryParameters.subscription_id;

    $scope.subscription = {
      country_code: queryParameters.country_code,
      email       : '',
      password    : '',
      unlock_code : '',
      username    : queryParameters.email
    };

    workshopAPI.get('/system/country_types', null, null, {
      bypass: true
    })
    .then(countries => {
      $scope.country_codes = countries;
    });
  };

  $scope.save = function ( form ) {
    workshopAPI.post('/subscriptions/first_user_setup', $scope.subscription)
    .then(() => {
      messages.show($translate.instant('JS_SPACE.MESSAGES.USER_CREATED_CHARGIFY'), 'success');

      loginApi.login($scope.subscription);
    })
    .catch(err => {
      messages.error(err);
    });
  };

  if ($scope.customer_id && $scope.subscription_id) {
    workshopAPI.get(`/subscriptions/verify_chargify_subscription/${$scope.customer_id}/${$scope.subscription_id}`)
    .catch(err => {
      messages.error(err);
    });
  }

  $scope.init();
}